<template>
  <v-timeline-item
    dot-color="leadActivity"
    icon="mdi-phone"
    fill-dot
  >
    <v-expansion-panels
      class="expansion-panels"
      variant="accordion"
      flat
    >
      <v-expansion-panel>
        <v-expansion-panel-title>
          <v-row
            no-gutters
            align="center"
            class="justify-center d-flex"
            :class="{ 'flex-column': $vuetify.display.smAndDown }"
          >
            <v-col md="8">
              <div class="mb-2 text-subtitle-1">
                {{ $t('lead-timeline.return-call.title') }}
              </div>
              <div class="text-grey">
                {{ callbackTimeOfDay }} {{ $t('lead-timeline.return-call.topics') }} {{ topics }}
              </div>
            </v-col>
            <v-col
              class="pr-2 text-right text-grey"
              :class="{ 'text-start mt-2': $vuetify.display.smAndDown }"
              md="4"
            >
              {{ formatDate(data.createdAt) }}
            </v-col>
          </v-row>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-row>
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title :title="$t('labels.source')"
                    >{{ $t('labels.source') }}:</v-list-item-title
                  >
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ source }}
                  </div>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title :title="$t('lead-timeline.return-call.contact')">
                    {{ $t('lead-timeline.return-call.contact') }}:
                  </v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ name }}
                  </div>
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ phone }}
                  </div>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title :title="$t('lead-timeline.return-call.callback-time')">
                    {{ $t('lead-timeline.return-call.callback-time') }}:
                  </v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ callbackTimeOfDay }}
                  </div>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title :title="$t('labels.topic')"
                    >{{ $t('labels.topic') }}:</v-list-item-title
                  >
                  <div class="text-grey text--darken-3 text-body-2">
                    <span> {{ topics }} </span>
                  </div>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>

          <UtmParametersDisplay :utm-params="conversion?.utmParams" />

          <!-- Render custom fields from the conversion if available -->
          <v-row v-if="conversion.customFields?.length">
            <v-col
              v-for="(field, index) in conversion.customFields"
              cols="12"
              md="6"
              :key="index"
              class="py-0"
            >
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title :title="field.label">{{ field.label }}:</v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ field.value }}
                  </div>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-timeline-item>
</template>

<script>
import { timeToLabelMap } from '@/lib/callbackTimeOfDay'
import { conversionSource } from '@/lib/conversionSource'
import { topicToLabelMap } from '@/lib/topics'

import CONVERSION from '../queries/Conversion.gql'
import UtmParametersDisplay from './UtmParametersDisplay.vue'

export default {
  components: {
    UtmParametersDisplay,
  },
  props: {
    data: { type: Object, default: null },
  },
  data() {
    return {
      conversion: null,
    }
  },
  computed: {
    name() {
      if (!this.conversion) return
      return `${this.conversion.personalData.firstname} ${this.conversion.personalData.lastname}`
    },
    phone() {
      if (!this.conversion) return
      return this.conversion.personalData.formattedPhone
    },
    callbackTimeOfDay() {
      if (!this.conversion) return
      return this.conversion?.returnCall?.callbackTimeOfDay
        .map((time) => this.$t(timeToLabelMap[time]))
        .join(', ')
    },
    topics() {
      if (!this.conversion) return
      // Provided OTHER topic
      if (this.conversion.returnCall.topics.includes('OTHER')) {
        if (this.conversion.returnCall.topicsOther.length > 0) {
          return this.conversion.returnCall.topicsOther
        }
        return this.$t('labels.other')
      }
      // Provided one of the default topics
      return topicToLabelMap[this.conversion.returnCall.topics[0]]
    },
    source() {
      if (!this.conversion) return
      return this.conversion.source || conversionSource[this.conversion.origin] || ''
    },
  },
  apollo: {
    conversion: {
      query: CONVERSION,
      variables() {
        return {
          conversionId: this.data.details[this.data.type].conversionId,
        }
      },
    },
  },
}
</script>

<style scoped>
.expansion-panels {
  margin: -24px -24px 0 -24px;
}
</style>
